<template>
  <div>
    <!-- ==================================== 임차인, 임대인 계약관리 ============================-->
    <div
      class="col-12 row jipvio-dashboard"
      v-if="sessionUserInfo.type == 'LE' || sessionUserInfo.type == 'LO'"
    >
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20">계약관리</h4>
        <div class="F_Menu ml-30" v-if="sessionUserInfo.type == 'LO'">
          <ul class="F_Menu_Select row">
            <li class="mr-10" v-for="(btn, index) in btnNameList1" :key="index">
              <el-Radio
                v-model="btnRadio"
                :label="btn.label"
                border
                @click="btnSelect = btn.value"
                >{{ btn.label }}</el-Radio
              >
            </li>
          </ul>
        </div>

        <card>
          <h4 class="card-title ml-20 mb-30">계약관리(체결한 계약)</h4>

          <div
            class="d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-primary mb-3 ml-20"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <fg-input class="mr-30">
              <el-popover
                class="fl mr-10"
                placement="bottom-start"
                width="70"
                trigger="click"
              >
                <el-checkbox
                  v-for="tc in tableColumns"
                  :key="tc.label"
                  :label="tc.label"
                  v-model="tc.vif"
                ></el-checkbox>

                <el-button class="pr-2 pl-2" slot="reference"
                  >필터 <i class="fas fa-angle-down"></i
                ></el-button>
              </el-popover>

              <el-select
                class="select-primary mb-3 fl mr-10"
                style="width: 200px"
                v-model="searchStd"
                placeholder="검색기준"
                @input="searchSetData(searchStd)"
              >
                <el-option
                  class="select-default"
                  v-for="tc in tableColumns"
                  :key="tc.label"
                  :label="tc.label"
                  :value="tc.label"
                >
                </el-option>
              </el-select>
              <el-autocomplete
                type="search"
                class="mb-3 fl"
                clearable
                style="width: 200px"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
                :fetch-suggestions="querySearchAsync"
                @select="handleSelect"
              >
              </el-autocomplete>
            </fg-input>
          </div>
          <el-table class="col-10" stripe :data="tableData">
            <el-table-column
              v-for="column in filteredColumns()"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              align="center"
              :sortable="column.sortable"
            >
            </el-table-column>

            <el-table-column
              :min-width="135"
              fixed="right"
              label="작업"
              align="center"
            >
              <template v-slot="props">
                <div class="table-actions">
                  <n-button
                    @click.native="handleLike(props.$index, props.row)"
                    class="like"
                    type="info"
                    size="sm"
                    round
                    icon
                  >
                    <i class="fa fa-heart"></i>
                  </n-button>
                  <n-button
                    @click.native="handleEdit(props.$index, props.row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    round
                    icon
                  >
                    <i class="fa fa-calendar"></i>
                  </n-button>
                  <n-button
                    @click.native="printData(props.$index, props.row)"
                    class="remove"
                    type="danger"
                    size="sm"
                    round
                    icon
                  >
                    <i class="fa fa-times"></i>
                  </n-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <n-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.totalCnt"
            >
            </n-pagination>
          </div>
        </card>
      </card>
    </div>

    <!-- ==================================== 공인중개사 계약관리 ============================-->
    <div class="row jipvio-dashboard" v-if="sessionUserInfo.type == 'AG'">
      <div class="col-8 mt-80 pt-30 Mgmtitle pr-0">
        <h2 class="ml-10">계약관리</h2>
        <div class="position-relative ml-10">
          <p class="fl" style="width:80%;">
            임대차 계약일정을 등록하여 관리하실 수 있습니다.
          </p>
          <router-link to="/mypage/cont/mgmt/agt/detail"
            ><el-button class="fr mb-20 mr-0" type="" icon="el-icon-circle-plus"
              >일정추가</el-button
            ></router-link
          >
        </div>
      </div>
      <div class="col-lg-8 pr-0">
        <card class="card-calendar">
          <fullCalendar
            class="col-md-12"
            ref="calendar"
            defaultView="dayGridMonth"
            locale="ko"
            height="auto"
            :plugins="calendarPlugins"
            :events="events"
            :selectable="true"
            @dateClick="dateClick"
            :header="header"
            :buttonIcons="buttonIcons"
            :buttonText="buttonText"
            :selectHelper="true"
            :editable="true"
          />
        </card>
      </div>
      <div class="col-lg-4">
        <div class="card card-tasks mr-10">
          <div class="card-header ">
            <h5 class="card-category">메모</h5>
            <h4 class="card-title">해야할 일</h4>
          </div>
          <div class="card-body ">
            <div class="table-full-width table-responsive">
              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            checked=""
                          />
                          <span class="form-check-sign"></span>
                        </label>
                      </div>
                    </td>
                    <td class="text-left">
                      계약서 작성, 서류 준비
                    </td>
                    <td class="td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title=""
                        class="btn btn-info btn-round btn-icon btn-icon-mini btn-neutral"
                        data-original-title="Edit Task"
                      >
                        <i class="now-ui-icons ui-2_settings-90"></i>
                      </button>
                      <button
                        type="button"
                        rel="tooltip"
                        title=""
                        class="btn btn-danger btn-round btn-icon btn-icon-mini btn-neutral"
                        data-original-title="Remove"
                      >
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" />
                          <span class="form-check-sign"></span>
                        </label>
                      </div>
                    </td>
                    <td class="text-left">
                      vr 사진 촬영
                    </td>
                    <td class="td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title=""
                        class="btn btn-info btn-round btn-icon btn-icon-mini btn-neutral"
                        data-original-title="Edit Task"
                      >
                        <i class="now-ui-icons ui-2_settings-90"></i>
                      </button>
                      <button
                        type="button"
                        rel="tooltip"
                        title=""
                        class="btn btn-danger btn-round btn-icon btn-icon-mini btn-neutral"
                        data-original-title="Remove"
                      >
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            checked=""
                          />
                          <span class="form-check-sign"></span>
                        </label>
                      </div>
                    </td>
                    <td class="text-left">
                      잔금 서류 매도인, 매수인에게 안내하기, 잔금시 필요 서류
                      확인
                    </td>
                    <td class="td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title=""
                        class="btn btn-info btn-round btn-icon btn-icon-mini btn-neutral"
                        data-original-title="Edit Task"
                      >
                        <i class="now-ui-icons ui-2_settings-90"></i>
                      </button>
                      <button
                        type="button"
                        rel="tooltip"
                        title=""
                        class="btn btn-danger btn-round btn-icon btn-icon-mini btn-neutral"
                        data-original-title="Remove"
                      >
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer ">
            <hr />
            <div class="stats">
              <i class="now-ui-icons loader_refresh spin"></i> 3분 전 업데이트됨
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Button,
  Radio,
  Popover,
  Checkbox,
  CheckboxGroup,
  Autocomplete
} from "element-ui";
import { Pagination as NPagination } from "@/components";
import { Button as NButton } from "@/components";
import card from "@/components/Cards/Card.vue";
import propApi from "@/service/property";

import { createNamespacedHelpers } from "vuex";

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

// 공인중개사 needs =====================================================
import Swal from "sweetalert2";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import koLocale from "@fullcalendar/core/locales/ko";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();
// ===========================================================================

export default {
  components: {
    NPagination,
    NButton,
    card,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Popover.name]: Popover,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Autocomplete.name]: Autocomplete,
    FullCalendar
  },

  data() {
    return {
      btnRadio: "",

      btnNameList1: {
        apt: {
          label: "아파트",
          value: "AP"
        },
        vil: {
          label: "빌라",
          value: "VL"
        },
        ho: {
          label: "주택",
          value: "HO"
        },
        op: {
          label: "오피스텔",
          value: "OP"
        },
        or: {
          label: "원룸",
          value: "OR"
        }
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        totalCnt: 0,
        totalPages: 10
      },
      searchStd: null,
      searchQuery: "",

      tableColumns: {
        CTT: {
          prop: "typeId",
          label: "거래형태",
          minWidth: 125,
          sortable: true,
          vif: true
        },
        purpsCd: {
          prop: "purpsCd",
          label: "종류",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        bldNm: {
          prop: "addr",
          label: "건물명",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        dong: {
          prop: "newAddr",
          label: "법정동",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        JiBun: {
          prop: "newAddr",
          label: "지번",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        area: {
          prop: "useArea",
          label: "면적",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        deposit: {
          prop: "useIds",
          label: "보증금",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        monthlyPay: {
          prop: "useIds",
          label: "월세",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        possibleMoveDate: {
          prop: "updatedDate",
          label: "입주가능일",
          minWidth: 150,
          sortable: true,
          vif: true
        },
        updatedDate: {
          prop: "updatedDate",
          label: "등록일",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        extraInfo: {
          prop: "updatedDate",
          label: "추가설명",
          minWidth: 125,
          sortable: false,
          vif: true
        }
      },
      tableData: null,

      // =========================================공인중개사

      calendarPlugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
      header: {
        center: "dayGridMonth,timeGridWeek,timeGridDay",
        right: "prev,next,today"
      },
      buttonIcons: {
        close: "fa-times",
        prev: "fc-icon-left-single-arrow",
        next: "fc-icon-right-single-arrow",
        prevYear: "fc-icon-left-single-arrow",
        nextYear: "fc-icon-right-single-arrow"
      },
      buttonText: {
        today: "오늘",
        day: "일",
        week: "주",
        month: "월"
      },
      events: [
        {
          title: "계약일",
          start: new Date(y, m, 1),
          className: "event-default"
        },
        {
          id: 999,
          title: "중도금",
          start: new Date(y, m, d - 4, 6, 0),
          allDay: false,
          className: "event-rose"
        },
        {
          id: 999,
          title: "잔금",
          start: new Date(y, m, d + 3, 6, 0),
          allDay: false,
          className: "event-rose"
        },
        {
          title: "중도금",
          start: new Date(y, m, d - 1, 10, 30),
          allDay: false,
          className: "event-green"
        },
        {
          title: "잔금",
          start: new Date(y, m, d + 7, 12, 0),
          end: new Date(y, m, d + 7, 14, 0),
          allDay: false,
          className: "event-red"
        },
        {
          title: "중도금",
          start: new Date(y, m, d - 2, 12, 0),
          allDay: true,
          className: "event-azure"
        },
        {
          title: "계약일",
          start: new Date(y, m, d + 1, 19, 0),
          end: new Date(y, m, d + 1, 22, 30),
          allDay: false,
          className: "event-azure"
        },
        {
          title: "계약일",
          start: new Date(y, m, 21),
          end: new Date(y, m, 22),
          className: "event-orange"
        },
        {
          title: "계약일",
          start: new Date(y, m, 21),
          end: new Date(y, m, 22),
          className: "event-orange"
        }
      ]
    };
  },

  created() {
    console.log("======매물관리");
    console.log(this.sessionUserInfo);
    if (this.sessionUserInfo.type == "LE") {
      //실제로는 임차인 param 넘겨서 정보 불러오기
      this.getAllProperty();
    } else if (this.sessionUserInfo.type == "LO") {
      //실제로는 임대인 param 넘겨서 정보 불러오기
      this.getAllProperty();
    } else if (this.sessionUserInfo.type == "AG") {
      //실제로는 공인중개사 param 넘겨서 정보 불러오기
      //this.getAllProperty();
    }
  },

  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo"
    }),
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalCnt;
    }
  },

  methods: {
    searchSetData(value) {
      this.searchQuery = "";
      let selectData = [];
      if (value == "거래형태") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          // selectData.push(ele.paymentType);
          selectData.push(ele.typeId);
        });
      } else if (value == "종류") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          // selectData.push({ value: ele.type });
          selectData.push(ele.purpsCd);
        });
      } else if (value == "건물명") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.addr);
        });
      } else if (value == "법정동") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.newAddr);
        });
      } else if (value == "지번") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.newAddr);
        });
      } else if (value == "면적") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.useArea);
        });
      } else if (value == "보증금") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(String(ele.useIds));
        });
      } else if (value == "월세") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(String(ele.payment));
        });
      } else if (value == "등록일") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.updatedDate);
        });
      } else if (value == "제목") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.qstTitle);
        });
      } else if (value == "답변상태") {
        console.log(value);
        this.tableData.forEach((ele, dex) => {
          selectData.push(ele.answState);
        });
      }

      /* 중복 확인 및 제거 */
      selectData = Array.from(new Set(selectData));

      /* value값으로 만들어 주지 않으면 읽지 못함 */
      if (selectData.length > 0) {
        let values = [];
        for (let i = 0; i < selectData.length; i++) {
          values.push({
            label: value,
            value: selectData[i]
          });
        }
        this.selects = values;
      }
      console.log("=======================this.searchData");
      console.log(this.selects);
    },

    querySearchAsync(queryString, cb) {
      let searchResult = this.selects;

      let results = queryString
        ? searchResult.filter(this.createFilter(queryString))
        : searchResult;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },
    createFilter(queryString) {
      return el => {
        return el.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      console.log("=================handleSelect");
      if (this.searchStd == "거래형태") {
        this.paymentTypeCode = item.value;
      } else if (this.searchStd == "종류") {
        this.bldTypeCode = item.value;
      }
      // this.getAllProperty();
    },

    bldName(code) {
      if (this.btnSelected == code) {
        this.btnSelected = null;
        this.bldTypeCode = null;
      } else {
        this.btnSelected = code;
        this.bldTypeCode = code;
      }
      console.log(this.bldTypeCode);
    },

    printData(index, row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      console.log("here");
      console.log(index);
      console.log(row);
      console.log(indexToDelete);
    },

    handleLike(index, row) {
      Swal.fire({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill"
      });
    },
    handleEdit(index, row) {
      Swal.fire({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill"
      });
    },
    handleDelete(index, row) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          Swal.fire({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },

    async getAllProperty() {
      const pagingReq = {
        pageNo: this.pagination.currentPage - 1,
        sizePerPage: this.pagination.perPage,
        swLat: 37.66258399481432,
        swLng: 127.04401962842194,
        neLat: 37.66762719185185,
        neLng: 127.04979178950516
      };

      const res = await propApi.getAllProperty(pagingReq);

      this.pagination.perPage = res.pagingInfo.size;
      this.pagination.currentPage = res.pagingInfo.pageNo + 1;
      this.pagination.totalCnt = res.pagingInfo.totalCnt;
      this.pagination.totalPages = res.pagingInfo.totalPages;
      this.tableData = res.payload;
    },

    filteredColumns() {
      const newTbColumns = _.cloneDeep(this.tableColumns);
      for (let key in newTbColumns) {
        if (newTbColumns[key].vif == false) {
          delete newTbColumns[key];
        }
      }
      console.log(newTbColumns);
      return newTbColumns;
    },

    // 공인중개사 method
    dateClick: function(info) {
      // on select we show the Sweet Alert modal with an input
      Swal.fire({
        title: "Create an Event",
        html: `<div class="form-group">
          <input type="text" id="vnud-input" class="form-control">
          </div>`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: false
      }).then(() => {
        var eventTitle = document.getElementById("vnud-input").value;
        if (eventTitle) {
          let calendarApi = this.$refs.calendar.getApi();
          calendarApi.addEvent({
            title: eventTitle,
            start: info.dateStr,
            allDay: true
          });
        }
      });
    }
  },
  mounted() {},
  watch: {
    "pagination.currentPage"(newValue, oldValue) {
      this.getAllProperty();
    },
    "pagination.perPage"(newValue, oldValue) {
      this.pagination.currentPage = 1;
      this.getAllProperty();
    }
  }
};
</script>
<style>
.el-loading-spinner .path {
  stroke: #66615b !important;
}
.jipvio-dashboard .form-check .form-check-label {
  margin-bottom: 0;
}
</style>
